<template >
  <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
    <v-layout row wrap>
    <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
      <v-layout row wrap>
        <v-flex xs12 sm12 md7 lg7 xl7 style="padding:15px;">
          <div style="padding-top:23px;font-weight:bolder;font-size:20px">داشبورد</div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-top:2px !important;padding-bottom:2px !important"><!--Row #2-->
      <v-layout row wrap>
        <v-flex xs12 md4 lg4 xl4 style="padding:15px;padding-bottom:2px !important">
          <v-card  class="sweet-morning-bg" style="color:#fff">
            <v-card-title style="font-weight:bolder;font-size:20px;border-bottom:1px solid #fff">
              درآمد امروز
            </v-card-title>
            <v-card-text>
              <v-overlay absolute :value="LoadingTodayIncome">
                <v-progress-circular indeterminate color="#f32148"></v-progress-circular>
              </v-overlay>
              <v-layout row wrap>
                
                <v-flex xs12 md12 lg12 xl12 class="white--text" style="padding:15px;font-weight:bolder;font-size:27px">
                  {{TodayIncomeNumber}} تومان
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md4 lg4 xl4 style="padding:15px;padding-bottom:2px !important">
          <v-card class="friday-bg" dark  color="#fff">
            <v-card-title style="font-weight:bolder;font-size:20px;border-bottom:1px solid #fff">
              فروش محصولات
            </v-card-title>
            <v-card-text>
              <v-overlay absolute :value="LoadingTodaySale">
                <v-progress-circular indeterminate color="#f32148"></v-progress-circular>
              </v-overlay>
              <v-layout row wrap>
                
                <v-flex xs12 md12 lg12 xl12 class="white--text" style="padding:15px;font-weight:bolder;font-size:27px">
                 {{TodaySaleNumber}}
                </v-flex>
              </v-layout>
            </v-card-text>
           
          </v-card>
        </v-flex>
        <v-flex xs12 md4 lg4 xl4 style="padding:15px;padding-bottom:2px !important">
          <v-card dark class="anamnisar-bg"  color="#fff">
            <v-card-title style="font-weight:bolder;font-size:20px;border-bottom:1px solid #fff">
              مشتری جدید
            </v-card-title>
            <v-card-text>
              <v-overlay absolute :value="LoadTodayCustomersLoading">
                <v-progress-circular indeterminate color="#f32148"></v-progress-circular>
              </v-overlay>
              <v-layout row wrap>
                
                <v-flex xs12 md12 lg12 xl12 class="white--text" style="padding:15px;font-weight:bolder;font-size:27px">
                 {{TodayCustomersNum}}
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        
      </v-layout>
    </v-flex>
    <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-top:2px !important;padding-bottom:2px !important"><!--Row #3-->
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12 xl12 style="padding:15px;">
          <v-card color="#fff" >
            <v-card-title>
              <div class="BoldFont">فروش 6 ماهه اخیر</div>
            </v-card-title>
            <v-card-text>
              <v-overlay absolute :value="LoadSixMonthLoading">
                <v-progress-circular indeterminate color="#f32148"></v-progress-circular>
              </v-overlay>
              <apexchart type="area" ref="AreaChart" :options="AreaChartOption" :series="AreaChartSeries"></apexchart>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-top:2px !important;padding-bottom:2px !important"><!--Row #4-->
      <v-layout row wrap>
        <v-flex xs12 sm12 md7 lg7 xl7 style="padding:15px;">
          <v-card>
            <v-card-title>
              جدیدترین سفارشات <v-spacer></v-spacer><v-btn v-if="0 == 100" small outlined color="#262d47" dark><v-icon style="padding-left:5px;" small>fa fa-file-export</v-icon>دریافت اکسل</v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table  :loading="loadingOrders" :items="recentOrdersTableItems" :headers="recentOrdersTableHeader">
                
                <template v-slot:[`item.showFactor`]="{item}">
                  <v-btn small icon   :href="'https://saviz.com/Print/'+item.orderNumber"><v-icon small color="blue" >fas fa-print</v-icon></v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md5 lg5 xl5 style="padding:15px;">
          <v-card>
            <v-card-title>
              فروش بر اساس دسته بندی محصول
            </v-card-title>
            <v-card-text>
              <v-overlay absolute :value="LoadingSaleByCategory">
                <v-progress-circular indeterminate color="#f32148"></v-progress-circular>
              </v-overlay>
              <apexchart type="donut" ref="SaleByCatChart" :series="donutseries" :options="donutchartOptions"></apexchart>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
  </div>
</template>

<script>
const ApiUrl = require("../constant/apiurl");
const MSGHNDL = require("../constant/MessageHandler");

const axios = require('axios');
import JsonExcel from 'vue-json-excel'
import { async } from 'q';
import VueApexCharts from 'vue-apexcharts'
export default {
  name: "Home",
  components: {
   apexchart:VueApexCharts,
   JsonExcel
  },
  data:()=>({
    AreaChartOption:{
      colors:["#262d47","#f75314","#388E3C","#0288D1"],
      chart: {
         toolbar: {
           show:false
         },
        stacked:false,
        id: 'vuechart-example2'
      },
      xaxis: {
        categories: []
      },
      fill: {
              type: 'gradient',
              gradient: {
                  shadeIntensity: 1,
                  inverseColors: false,
                  opacityFrom: 0.45,
                  opacityTo: 0.05,
                  stops: [20, 100, 100, 100]
                },
            },
            
    },
    options: {
      colors:["#f75314","#262d47","#388E3C","#0288D1"],
      chart: {
         toolbar: {
           show:false
         },
        stacked:true,
        id: 'vuechart-example'
      },
      xaxis: {
        categories: ["June", 1992, 1993, 1994, 1995, 1996, 1997, 1998]
      }
    },
    chartOptions: 
    {
      labels: ['Apple', 'Mango', 'Orange', 'Watermelon']
    },
    series: [{
        name: 'series-1',
        data: [30, 40, 45, 50, 49, 60, 70, 91]
    }],
    AreaChartSeries:[
     {data:[],name:"فروش "}
    ],
    donutseries: [],
    donutchartOptions: {
      colors:["#E65100","#2962FF","#009688","#C51162","#FF1744","#4A148C","#F44336","#E1BEE7","#00BCD4","#CDDC39","#4CAF50","#43A047","#69F0AE","#B2FF59"],
      labels: [],
      chart: {
        type: 'donut',
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
    recentOrdersTableHeader:[
      {text:"شماره فاکتور",value:"orderNumber",sortable:false,align:"right"},
      {text:"مشتری",value:"orderCustomer",sortable:false,align:"right"},
      {text:"تاریخ سفارش",value:"orderDate",sortable:false,align:"right"},
      {text:"جمع فاکتور",value:"orderSum",sortable:false,align:"right"},
      {text:"وضعیت سفارش",value:"orderStateStr",sortable:false,align:"right"},
      {text:"چاپ",value:"showFactor",sortable:false,align:"right"},
    ],
    recentOrdersTableItems:[
    ],
    EndDateText:"",
    EndDateMenuModel:false,
    StartDateMenuModel:false,
    StartDateText:"",
    value: [
        423,
        446,
        675,
        510,
        590,
        610,
        760,
      ],
    loadingOrders:true,
    LoadingSaleByCategory:true,
    LoadingTodayIncome:true,
    TodayIncomeNumber:0,
    TodayIncomeChange:0,
    TodayIncomeChartData:[],
    TodaySaleChartData:[],
    TodaySaleNumber:0,
    TodaySaleChange:0,
    LoadingTodaySale:true,
    LoadSixMonthLoading:true,
    LoadTodayCustomersLoading:true,
    TodayCustomersNum:0,
    TodayNewCustomChange:0,
    TodayNewCustomChartData:[]
  }),
  async created(){
    await this.LoadLastOrders();
  },
  methods:{
    async LoadLastOrders()
    {
      var vm = this;
      vm.loadingOrders = true;
      await axios.post(ApiUrl.LoadOrders)
      .then(async (res)=>{
        var data = res.data;
        vm.loadingOrders = false;
        if(data.status)
        {
          vm.recentOrdersTableItems = data.data;
        }
        await vm.LoadSaleByCategory();
      })
      .catch((err)=>{this.loadingOrders = false;console.error(err);});
    },
    async LoadSaleByCategory()
    {
      var vm = this;
      vm.LoadingSaleByCategory = true;
      await axios.post(ApiUrl.SaleByCategory)
      .then(async (res)=>{
        var data = res.data;
        vm.LoadingSaleByCategory = false;
        if(data.status)
        {
          vm.donutchartOptions.labels = data.data.labels;
          console.warn("Sale bu category : ",data.data);
          vm.donutseries = data.data.series;
          vm.$refs.SaleByCatChart.updateOptions({labels: data.data.labels,series : data.data.series});
        }
        await vm.LoadTodayIncome();
      })
      .catch((err)=>{this.LoadingSaleByCategory = false;console.error(err);});
    },
    async LoadTodayIncome()
    {
      var vm = this;
      vm.LoadingTodayIncome = true;
      await axios.post(ApiUrl.TodayIncome)
      .then(async (res)=>{
        var data = res.data;
        vm.LoadingTodayIncome = false;
        if(data.status)
        {
          vm.TodayIncomeNumber = data.data.income;
          
        }
        await vm.LoadTodaySale();
      })
      .catch((err)=>{this.LoadingTodayIncome = false;console.error(err);});
    },
    async LoadTodaySale()
    {
      var vm = this;
      vm.LoadingTodaySale = true;
      await axios.post(ApiUrl.TodaySale)
      .then(async (res)=>{
        var data = res.data;
        vm.LoadingTodaySale = false;
        if(data.status)
        {
          vm.TodaySaleNumber = data.data.income;
        
        }
        await vm.LoadTodayCustomers();
      })
      .catch((err)=>{this.LoadingTodaySale = false;console.error(err);});
    },
    async LoadTodayCustomers()
    {
      var vm = this;
      vm.LoadTodayCustomersLoading = true;
      await axios.post(ApiUrl.TodayCustomers)
      .then(async (res)=>{
        var data = res.data;
        vm.LoadTodayCustomersLoading = false;
        if(data.status)
        {
          vm.TodayCustomersNum = data.data.income;
          
        }
        await vm.LoadSixMonth();
      })
      .catch((err)=>{this.LoadTodayCustomersLoading = false;console.error(err);});
    },
    async LoadSixMonth()
    {
      var vm = this;
      vm.LoadSixMonthLoading = true;
      await axios.post(ApiUrl.LastSixMonth)
      .then(async (res)=>{
        var data = res.data;
        vm.LoadSixMonthLoading = false;
        if(data.status)
        {
          console.warn("Last Six Month: ",data);
         vm.AreaChartOption.xaxis.categories = data.data.series;
          vm.AreaChartSeries[0].data = data.data.values;
           vm.$refs.AreaChart.updateOptions({xaxis: vm.AreaChartOption.xaxis});
          console.warn( vm.AreaChartOption,vm.AreaChartSeries);
        }
      })
      .catch((err)=>{this.LoadSixMonthLoading = false;console.error(err);});
    },
    ChangePercColor(c)
    {
      if(c < 0)
       return "#D32F2F";

      if(c > 0)
       return "#5dd9ab";

       if(c == 0)
        return "#FFC107";
    }
  },
    
  
};
</script>
<style>
.anamnisar-bg
{
  background: #9796f0;  /* fallback for old browsers */
background: -webkit-linear-gradient(to right, #fbc7d4, #9796f0);  /* Chrome 10-25, Safari 5.1-6 */
background: linear-gradient(to right, #fbc7d4, #9796f0); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}
.cherry-bg
{
  background: #EB3349;  /* fallback for old browsers */
background: -webkit-linear-gradient(to right, #F45C43, #EB3349);  /* Chrome 10-25, Safari 5.1-6 */
background: linear-gradient(to right, #F45C43, #EB3349); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}
.friday-bg
{
  background: #83a4d4;  /* fallback for old browsers */
background: -webkit-linear-gradient(to right, #b6fbff, #83a4d4);  /* Chrome 10-25, Safari 5.1-6 */
background: linear-gradient(to right, #b6fbff, #83a4d4); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}
.sweet-morning-bg
{
   background: #ff5f6d; /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #ff5f6d, #ffc371); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #ff5f6d, #ffc371); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.orderDeclined
{
  color: #ff5c75 !important;
  background-color: rgba(255,92,117,.2);
  display: inline-block;
  padding: .3em .5em;
  font-size: 82%;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .2rem;
  -webkit-transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
}
.orderPending
{
  color: #ffbe0b !important;
  background-color: rgba(255,190,11,.2);
  display: inline-block;
  padding: .3em .5em;
  font-size: 82%;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .2rem;
  -webkit-transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
}
.orderDelivered
{
  color:#43d39e !important;
  background-color: rgba(67,211,158,.2);
  display: inline-block;
  padding: .3em .5em;
  font-size: 82%;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .2rem;
  -webkit-transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
}
.categoryStyle
{
  color: #000000 !important;
  background-color: rgba(184, 184, 184, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.589);
  border-radius: 2px;
  display: inline-block;
  padding: .3em .5em;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .2rem;
  -webkit-transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
}
.BoldFont
{
  font-weight: 700;
}
</style>
<style>
.apexcharts-tooltip-text,.apexcharts-tooltip,.apexcharts-bar-area,.apexcharts-text ,.apexcharts-xaxis-label ,.apexcharts-legend-text
{
  font-family: Vazir !important;
}
.apexcharts-legend-text
{
  padding-right: 3px;
}
</style>